import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class Note {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.dataReport}/report/note`;

    async save(noteData) {
        if (!noteData) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/save`,
                noteData
            );
            return response?._id;
        } catch (err) {
            throw new Error(err?.message || "Erro ao salvar nota");
        }
    }

    async get({ accountingId, companyId, reportId, options }) {
        if (!accountingId || !companyId) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-company`,
                { accountingId, companyId, reportId, options }
            );
            return response || [];
        } catch (err) {
            throw new Error(err?.message || "Erro ao buscar nota");
        }
    }

    async remove(noteId) {
        if (!noteId) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/remove-by-id`,
                { _id: noteId }
            );
            return response;
        } catch (err) {
            throw new Error(err?.message || "Erro ao remover nota");
        }
    }
}
